import { CircularProgressModule } from './../circular-progress/circular-progress.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ChipsAutocompleteComponent } from './chips-autocomplete.component';
import { ChipsAutocompleteDirective } from './chips-autocomplete.directive';

@NgModule({
  declarations: [ChipsAutocompleteComponent, ChipsAutocompleteDirective],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    CircularProgressModule,
    FormsModule,
  ],
  exports: [ChipsAutocompleteComponent, ChipsAutocompleteDirective],
})
export class ChipsAutocompleteModule {}
